export default function MethodologyDisclaimer({ compact = false }) {
  return (
    <div className="disclaimer-block" data-testid="methodology-disclaimer">
      <div className="label-mono mb-2">Методологическое примечание</div>
      <p className={compact ? "text-sm" : "text-sm md:text-base"}>
        Оценка не является прогнозом получения инвестиций, гранта или корпоративного пилота.
        Она показывает, насколько параметры проекта похожи на признаки, которые в исследовательской
        базе чаще связаны с найденными сигналами интереса.
      </p>
    </div>
  );
}
